import { Avatar, FormControlLabel, Stack, Switch } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { toggleV, toggleX } from 'Images';
import { sendEvent } from 'Utils/sendEvent';

interface IShowPaychecksToggle {
  showPaychecks: boolean;
  setShowPaychecks: (value: boolean) => void;
}

export const ShowPaychecksToggle = ({
  showPaychecks,
  setShowPaychecks,
}: IShowPaychecksToggle) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userPaychecks;

  return (
    <Stack
      flexDirection='row'
      justifyContent='space-between'
      alignItems='center'
      sx={{
        bgcolor: 'primary.shade_100',
        borderRadius: '12px',
        p: '5px 12px',
      }}
    >
      <FormControlLabel
        control={
          <Switch
            role='switch'
            aria-checked={showPaychecks}
            tabIndex={0}
            aria-label={dictionary.showNumbers}
            checked={showPaychecks}
            onChange={() => {
              sendEvent('Payslips', 'AmountsToggle');
              setShowPaychecks(!showPaychecks);
            }}
            icon={
              <Avatar
                src={toggleX}
                alt=''
                sx={{ width: '8px', height: '8px' }}
              />
            }
            checkedIcon={
              <Avatar
                src={toggleV}
                alt=''
                sx={{ width: '8px', height: '8px' }}
              />
            }
            sx={{
              '& .MuiSwitch-thumb': {
                backgroundColor: showPaychecks ? '#ec0000' : 'green',
                p: 0,
                m: 0,
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'row-reverse',
                width: '100%',
                '& .MuiFormControlLabel-label': { fontSize: '16px' },
                '& .MuiSwitch-track': {
                  borderRadius: '25px',
                  opacity: 1,
                  padding: '9px 19px',
                },
              },
            }}
          />
        }
        label={dictionary.showNumbers}
        sx={{
          p: 0,
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row-reverse',
          width: '100%',
          '& .MuiFormControlLabel-label': { fontSize: '16px' },
          '& .MuiSwitch-switchBase': {
            backgroundColor: '#fff',
            boxShadow: 'none',
            width: 16,
            height: 16,
            margin: '10px',
            p: 0,
          },
          '& .Mui-checked:hover': {
            bgcolor: '#fff',
          },
          m: 0,
        }}
      />
    </Stack>
  );
};
